/* Custom Lithium animated touches: small illustrations that play while they're on screen.
   Scroll position drives the main story; a light loop keeps the power pulses moving. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var GREEN = '#06A74F', LIME = '#A1CD3A', GREY = '#9AA6A0', AMBER = '#E3B230';
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var ease = function (t) { t = clamp(t, 0, 1); return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var uid = 0;
  function el(parent, tag, attrs, text) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    if (parent) parent.appendChild(n);
    return n;
  }
  function svg(host, w, h, label) {
    var s = el(null, 'svg', { viewBox: '0 0 ' + w + ' ' + h, role: 'img', 'aria-label': label, fill: 'none' });
    s.style.width = '100%'; s.style.height = 'auto'; s.style.display = 'block'; s.style.overflow = 'visible';
    host.appendChild(s);
    return s;
  }
  var text = function (s, x, y, t, o) {
    o = o || {};
    return el(s, 'text', { x: x, y: y, 'text-anchor': o.anchor || 'start', 'font-size': o.size || 16, 'font-weight': o.weight || 400, fill: o.fill || 'currentColor', opacity: o.opacity == null ? 1 : o.opacity, 'font-family': 'Noto Sans, system-ui, sans-serif' }, t);
  };
  function battery(s, x, y, w, h, colour) {
    el(s, 'rect', { x: x, y: y, width: w, height: h, rx: h * 0.2, stroke: 'currentColor', 'stroke-width': 2.5, opacity: 0.9 });
    el(s, 'rect', { x: x + w, y: y + h * 0.3, width: 7, height: h * 0.4, rx: 2, fill: 'currentColor', opacity: 0.9 });
    var f = el(s, 'rect', { x: x + 6, y: y + 6, width: 0, height: h - 12, rx: h * 0.13, fill: colour || GREEN });
    return { set: function (v) { f.setAttribute('width', Math.max(0, (w - 12) * clamp(v, 0, 1))); }, fill: f };
  }
  var fade = function (node, v) { node.setAttribute('opacity', clamp(v, 0, 1)); };

  var TOUCHES = {
    // 1. Same size, twice the use
    usable: function (host) {
      var s = svg(host, 480, 210, 'A 100Ah AGM gives about 50Ah you can use; a 100Ah lithium battery gives the full 100Ah');
      var id = 'clhatch' + (++uid);
      var pat = el(el(s, 'defs', {}), 'pattern', { id: id, width: 8, height: 8, patternUnits: 'userSpaceOnUse', patternTransform: 'rotate(45)' });
      el(pat, 'line', { x1: 0, y1: 0, x2: 0, y2: 8, stroke: 'currentColor', 'stroke-width': 2, opacity: 0.35 });
      text(s, 0, 22, 'AGM 100Ah', { weight: 700 });
      var agm = battery(s, 0, 34, 340, 48, GREY);
      var hatch = el(s, 'rect', { x: 176, y: 40, width: 158, height: 36, rx: 6, fill: 'url(#' + id + ')', opacity: 0 });
      var hatchLabel = text(s, 255, 64, 'Not usable', { anchor: 'middle', size: 14, weight: 700, opacity: 0 });
      var agmV = text(s, 366, 66, '', { weight: 700, size: 20 });
      text(s, 0, 132, 'Lithium 100Ah', { weight: 700 });
      var li = battery(s, 0, 144, 340, 48, GREEN);
      var liV = text(s, 366, 176, '', { weight: 700, size: 20 });
      var plus = text(s, 366, 200, '+50Ah to use', { weight: 700, size: 14, fill: GREEN, opacity: 0 });
      return function (p, time) {
        var t = ease(seg(p, 0, 0.8));
        agm.set(0.5 * t); li.set(t);
        agmV.textContent = Math.round(50 * t) + 'Ah';
        liV.textContent = Math.round(100 * t) + 'Ah';
        var h = seg(p, 0.45, 0.8); fade(hatch, h); fade(hatchLabel, h);
        fade(plus, seg(p, 0.8, 1));
        if (time != null && p > 0.95) li.fill.setAttribute('opacity', 0.85 + 0.15 * Math.sin(time * 3));
      };
    },

    // 2. Full by dark
    sun: function (host) {
      var s = svg(host, 480, 270, 'The sun crosses the sky and solar fills the battery by evening');
      var arc = el(s, 'path', { d: 'M40 170 A200 140 0 0 1 440 170', stroke: 'currentColor', 'stroke-width': 1.5, 'stroke-dasharray': '3 6', opacity: 0.45 });
      el(s, 'line', { x1: 10, x2: 470, y1: 170, y2: 170, stroke: 'currentColor', 'stroke-width': 1.5, opacity: 0.35 });
      var halo = el(s, 'circle', { r: 24, fill: AMBER, opacity: 0.25 });
      var sun = el(s, 'circle', { r: 13, fill: AMBER });
      var drops = [0, 1, 2].map(function () { return el(s, 'circle', { r: 4, fill: AMBER, opacity: 0 }); });
      var bat = battery(s, 140, 192, 200, 44, GREEN);
      var pct = text(s, 240, 262, '', { anchor: 'middle', weight: 700, size: 18 });
      var len = arc.getTotalLength ? arc.getTotalLength() : 0;
      var pos = { x: 40, y: 170 };
      return function (p, time) {
        var t = ease(seg(p, 0, 0.9));
        if (len) { var pt = arc.getPointAtLength(len * t); pos = pt; sun.setAttribute('cx', pt.x); sun.setAttribute('cy', pt.y); halo.setAttribute('cx', pt.x); halo.setAttribute('cy', pt.y); }
        var level = 0.3 + 0.7 * t;
        bat.set(level);
        pct.textContent = Math.round(level * 100) + '%' + (level > 0.995 ? ' by sunset' : '');
        if (time == null) { drops.forEach(function (d) { d.setAttribute('opacity', 0); }); return; }
        halo.setAttribute('r', 22 + 4 * Math.sin(time * 2.4));
        var active = level < 0.995 ? 1 : 0;
        drops.forEach(function (d, i) {
          var k = (time * 0.7 + i / 3) % 1;
          d.setAttribute('cx', pos.x + (240 - pos.x) * k);
          d.setAttribute('cy', pos.y + (192 - pos.y) * k);
          d.setAttribute('opacity', active * 0.9 * Math.sin(Math.PI * k));
        });
      };
    },

    // 3. Starter battery, fuse, DC-DC charger, second battery
    cable: function (host) {
      var s = svg(host, 480, 200, 'Power runs from the starter battery through a fuse and a DC-DC charger to the second battery');
      text(s, 0, 30, 'Starter', { weight: 700 });
      var a = battery(s, 0, 44, 96, 42, GREEN);
      text(s, 467, 30, 'Second battery', { weight: 700, anchor: 'end' });
      var b = battery(s, 364, 44, 96, 42, GREEN);
      el(s, 'path', { d: 'M104 65 L208 65 M292 65 L356 65', stroke: 'currentColor', 'stroke-width': 2.5, opacity: 0.5 });
      var fuse = el(s, 'rect', { x: 130, y: 55, width: 28, height: 20, rx: 4, fill: 'none', stroke: AMBER, 'stroke-width': 2 });
      el(s, 'line', { x1: 134, x2: 154, y1: 65, y2: 65, stroke: AMBER, 'stroke-width': 1.5 });
      text(s, 144, 104, 'Fuse', { anchor: 'middle', size: 13, opacity: 0.8 });
      var dcdc = el(s, 'rect', { x: 208, y: 41, width: 84, height: 48, rx: 9, stroke: 'currentColor', 'stroke-width': 2.5, fill: 'none' });
      text(s, 250, 70, 'DC-DC', { anchor: 'middle', size: 15, weight: 700 });
      text(s, 250, 112, 'Charger', { anchor: 'middle', size: 13, opacity: 0.8 });
      var bPct = text(s, 412, 112, '', { anchor: 'middle', size: 15, weight: 700 });
      var dots = [0, 1, 2, 3].map(function () { return el(s, 'circle', { cy: 65, r: 5.5, fill: LIME, opacity: 0 }); });
      var note = text(s, 0, 170, '', { size: 15, opacity: 0.8 });
      a.set(1);
      return function (p, time) {
        var t = ease(seg(p, 0, 0.85));
        var level = 0.25 + 0.75 * t;
        b.set(level);
        bPct.textContent = Math.round(level * 100) + '%';
        var charging = level < 0.995;
        note.textContent = charging ? 'Charging as you drive' : 'Second battery full. Starter untouched.';
        dcdc.setAttribute('stroke', charging && p > 0.02 ? GREEN : 'currentColor');
        dcdc.setAttribute('fill', charging && p > 0.02 ? 'rgba(6,167,79,0.10)' : 'none');
        if (time == null) return;
        var nearFuse = 0;
        dots.forEach(function (d, i) {
          var k = (time / 2.2 + i / dots.length) % 1, x = 104 + 252 * k;
          d.setAttribute('cx', x);
          if (Math.abs(x - 144) < 16) nearFuse = 1;
          var hidden = x > 210 && x < 290;
          d.setAttribute('opacity', hidden ? 0 : (charging ? 0.95 : 0.3));
        });
        fuse.setAttribute('fill', nearFuse && charging ? 'rgba(227,178,48,0.45)' : 'none');
      };
    },

    // 4. Turn it side-on
    edge: function (host, cfg) {
      var s = svg(host, 480, 290, 'The battery turns side-on, showing how thin it is, and where it fits');
      var mm = cfg.thickness || 55;
      var cx = 240, top = 26, h = 160;
      var topFace = el(s, 'path', { fill: '#45B574' });
      var face = el(s, 'rect', { y: top, height: h, rx: 8, fill: '#2E9E5B' });
      var side = el(s, 'rect', { y: top, height: h, rx: 3, fill: '#1D6B3E' });
      var dim = el(s, 'g', { opacity: 0 });
      var line = el(dim, 'line', { y1: top + h + 22, y2: top + h + 22, stroke: 'currentColor', 'stroke-width': 2 });
      var t1 = el(dim, 'line', { y1: top + h + 12, y2: top + h + 32, stroke: 'currentColor', 'stroke-width': 2 });
      var t2 = el(dim, 'line', { y1: top + h + 12, y2: top + h + 32, stroke: 'currentColor', 'stroke-width': 2 });
      var lab = text(dim, cx, top + h + 56, '', { anchor: 'middle', weight: 700, size: 22 });
      var spots = ['Behind a seat', 'Under a floor', 'In a canopy wall'].map(function (w, i) {
        return text(s, [70, 240, 410][i], 282, w, { anchor: 'middle', size: 14, weight: 700, opacity: 0 });
      });
      return function (p) {
        var turn = ease(seg(p, 0, 0.55)), show = seg(p, 0.45, 0.75);
        var fw = 300 * (1 - turn) + 6 * turn, sw = 6 + 26 * turn, lift = 16 * (1 - turn) + 6 * turn;
        var x = cx - (fw + sw) / 2;
        face.setAttribute('x', x); face.setAttribute('width', fw);
        side.setAttribute('x', x + fw); side.setAttribute('width', sw);
        topFace.setAttribute('d', 'M' + (x + 4) + ' ' + top + ' L' + (x + fw + sw - 2) + ' ' + top + ' L' + (x + fw + sw + lift * 0.6) + ' ' + (top - lift) + ' L' + (x + lift * 0.6 + 4) + ' ' + (top - lift) + ' Z');
        dim.setAttribute('opacity', show);
        var l = x, r = x + fw + sw;
        line.setAttribute('x1', l); line.setAttribute('x2', r);
        t1.setAttribute('x1', l); t1.setAttribute('x2', l); t2.setAttribute('x1', r); t2.setAttribute('x2', r);
        lab.textContent = Math.round(mm * show) + 'mm';
        spots.forEach(function (sp, i) { fade(sp, seg(p, 0.72 + i * 0.09, 0.82 + i * 0.09)); });
      };
    },

    // 5. A night for every 100Ah
    nights: function (host, cfg) {
      var max = cfg.max || 1250;
      var s = svg(host, 480, 220, 'Capacity grows to ' + max + 'Ah, about one night for every 100Ah');
      var count = Math.round(max / 100), moons = [];
      for (var i = 0; i < count; i++) {
        var x = 16 + i * (448 / Math.max(1, count - 1)), r = 12;
        var g = el(s, 'g', { opacity: 0.15 });
        el(g, 'path', { d: 'M' + x + ' ' + (30 - r) + ' A' + r + ' ' + r + ' 0 1 0 ' + x + ' ' + (30 + r) + ' A' + (r * 0.7) + ' ' + r + ' 0 1 1 ' + x + ' ' + (30 - r) + ' Z', fill: 'currentColor' });
        moons.push({ g: g, x: x });
      }
      var nights = text(s, 0, 90, '', { weight: 700, size: 22 });
      el(s, 'rect', { x: 0, y: 108, width: 480, height: 30, rx: 15, stroke: 'currentColor', 'stroke-width': 1.5, opacity: 0.5 });
      var fill = el(s, 'rect', { x: 4, y: 112, height: 22, rx: 11, fill: GREEN });
      var glow = el(s, 'circle', { cy: 123, r: 9, fill: LIME, opacity: 0 });
      [100, 310, 620, max].forEach(function (c) { var x = 4 + 472 * c / max; text(s, Math.min(x, 476), 164, c + 'Ah', { anchor: c === max ? 'end' : 'middle', size: 13, opacity: 0.75 }); });
      return function (p, time) {
        var t = ease(seg(p, 0, 0.9)), c = 100 + (max - 100) * t;
        var w = 472 * c / max;
        fill.setAttribute('width', w);
        glow.setAttribute('cx', 4 + w - 6);
        glow.setAttribute('opacity', t > 0.02 && t < 0.995 ? 0.9 : time != null ? 0.35 + 0.25 * Math.sin(time * 3) : 0.3);
        var n = c / 100;
        moons.forEach(function (m, k) {
          var lit = clamp(n - k, 0, 1);
          m.g.setAttribute('opacity', 0.15 + 0.85 * lit);
          var sc = 0.75 + 0.25 * lit + (lit > 0 && lit < 1 ? 0.15 * Math.sin(Math.PI * lit) : 0);
          m.g.setAttribute('transform', 'translate(' + m.x + ' 30) scale(' + sc.toFixed(3) + ') translate(' + -m.x + ' -30)');
        });
        nights.textContent = Math.round(c) + 'Ah · about ' + (Math.round(n * 2) / 2).toString().replace('.5', '½') + (n < 1.5 ? ' night' : ' nights');
      };
    },
  };

  // 0 when the illustration's middle is near the bottom of the screen, 1 just above the middle
  function progressOf(el) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight || 800;
    var mid = r.top + r.height / 2;
    return clamp((vh * 0.9 - mid) / (vh * 0.5), 0, 1);
  }

  function mount(root) {
    if (root.__clTouch) return;
    root.__clTouch = true;
    var cfg = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var make = TOUCHES[cfg.touch];
    var host = root.querySelector('[data-cl-touch-art]');
    if (!make || !host) return;
    var draw = make(host, cfg);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { draw(1, null); return; }
    var p = progressOf(host), visible = false;
    var loop = function (ts) { draw(p, ts / 1000); if (visible) requestAnimationFrame(loop); };
    var onScroll = function () { p = progressOf(host); if (!visible) draw(p, null); };
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { var was = visible; visible = es[0].isIntersecting; if (visible && !was) requestAnimationFrame(loop); }).observe(host);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  window.CL = window.CL || {};
  window.CL.TOUCHES = TOUCHES;
  window.CL.mountTouches = function () { document.querySelectorAll('[data-cl-touch]').forEach(mount); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.CL.mountTouches); else window.CL.mountTouches();
  document.addEventListener('shopify:section:load', window.CL.mountTouches);
})();
